import React, { useState, useEffect } from 'react';
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import dataArray from './Util'
import { useHistory } from 'react-router-dom';
import * as Common from "../CommonControlls/CommonJs";
import DataGrid, { Column, Editing, Paging, Pager, Export } from 'devextreme-react/data-grid';
import 'devextreme/dist/css/dx.light.css';

const Help_List = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalRecord, setTotalRecord] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [dataArray1, setDataArray] = useState([]);
    const history = useHistory();

    useEffect(() => {
        PopulateTable()
        axios.get(Common.APILinks.HelpDesk_List)
            .then(response => {
                if (response.data && Array.isArray(response.data)) {
                    const formattedData = response.data.map(image => ({
                        ...image,
                        viewLink:Common.APILinks.OpenDocument+`${image.imageUrl}`
                    }));
                    setImages(formattedData);
                    setTotalRecord(formattedData.length);
                    console.log(Common.APILinks.HelpDesk_List)
                } else {
                    setImages([]);
                    setTotalRecord(0);
                }
            })
            .catch(error => {
                console.error('Error fetching images:', error);
                setImages([]);
                setTotalRecord(0);
            });
    }, [pageSize, pageNumber]);

    const handleRowClick = (rowId) => {
        const selectedRowData = images.find(image => image.id === rowId);
        if (selectedRowData) {
            setDataArray({ ...dataArray, Customer: selectedRowData });
            dataArray['Post'] = selectedRowData;
            history.push('/editpost');
        }
    };

    const handledeletedoc = async (id) => {
        
        try {

            const response = await fetch(Common.APILinks.HelpDesk_Delete + `/${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error('Error in deleting document');
            }
            if (response.ok) {
                RefreshTable();
                alert("Document deleted Successfully")
            }
        } catch (error) {
            console.error('There was an error deleting the document:', error);
        }
    };
    var BaseUrlAPI = process.env.REACT_APP_API_URL;

    const RefreshTable = async () => {
        try {
            const response = await axios.get(Common.APILinks.HelpDesk_List);

            if (response.data && Array.isArray(response.data)) {
                const formattedData = response.data.map(image => ({
                    ...image,
                    viewLink: BaseUrlAPI+`${image.imageUrl}`
                }));
                setImages(formattedData);
                setTotalRecord(formattedData.length);
            } else {
                setImages([]);
                setTotalRecord(0);
            }
        } catch (error) {
            console.error('Error fetching images:', error);
            setImages([]);
            setTotalRecord(0);
        }
    };

    const PopulateTable = () => {
        setLoading(true);

        var Parameters = {
            pageSize: pageSize,
            pageNumber: pageNumber,
        };
    };

    useEffect(() => {
        PopulateTable();
    }, [pageSize, pageNumber]);

    return (
        <div>
            <MainLayout />
            <div id="right-panel" className="right-panel">
                <Topmenu
                    PageTitle="Help Module"
                    isShowAddBtn={true}
                    AddBtnLabel="Add Help"
                    AddBtnLink="/HelpDesk_Add"
                />
                <div class="content">
                    <div class="PageHeader_Container">
                        <h2 class="Pageheading">Help Material</h2>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div>
                                {pageSize * (pageNumber - 1) + 1} to {Math.min(pageNumber * pageSize, TotalRecord)} of {TotalRecord} Results
                            </div>
                            <DataGrid
                                dataSource={images}
                                keyExpr="id"
                                allowColumnReordering={true}
                                allowColumnResizing={true}
                                showBorders={true}
                                showRowLines={true}
                                wordWrapEnabled={true}
                                remoteOperations={true}
                                onRowClick={handleRowClick}
                            >
                                <Paging defaultPageSize={pageSize} />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 20, 50]}
                                    showInfo={true}
                                    showNavigationButtons={true}
                                />
                                <Export enabled={true} />
                                <Column dataField="title" caption="Title" />
                                <Column dataField="youtubeVideoUrl" caption="YouTube URL" />
                                <Column
    caption="View"
    cellRender={(data) => (
        <a href={data.data.viewLink} target="_blank" rel="noopener noreferrer">View</a>
    )}
/>

                                <Column
                                    caption="Edit"
                                    cellRender={(data) => (
                                        <FontAwesomeIcon
                                            icon={faEdit}
                                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            onClick={() => handleRowClick(data.data.id)}
                                        />
                                    )}
                                />
                                <Column
                                    caption="Delete"
                                    cellRender={(data) => (
                                        <FontAwesomeIcon
                                            icon={faTrashAlt}
                                            style={{ marginLeft: '10px', cursor: 'pointer' }}
                                            onClick={() => handledeletedoc(data.data.id)}
                                        />
                                    )}
                                />
                            </DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Help_List;
